document.addEventListener("DOMContentLoaded", () => {
    const slidingSections = document.querySelectorAll(".sliding-images-section");

    slidingSections.forEach(slidingSection => {
        const tracks = slidingSection.querySelectorAll(".sliding-images .sliding-track");

        // === EVIGHETS-SCROLL ===
        // All slides in a track share the same width (a percentage of the track), so the width is measured
        // once (and again on resize) instead of calling getBoundingClientRect() every frame, which forced a
        // layout 60 times per second. The animation only runs while the section is near the viewport.
        const animations = [];

        tracks.forEach((slider, index) => {
            const isTop = index === 0;
            const speed = 50;
            let offset = 0;
            let lastTime = null;
            let running = false;
            let slideWidth = slider.children[0] ? slider.children[0].offsetWidth : 0;

            new ResizeObserver(() => {
                slideWidth = slider.children[0] ? slider.children[0].offsetWidth : 0;
            }).observe(slider);

            function tick(timestamp) {
                if (!running) return;
                if (!lastTime) lastTime = timestamp;
                const delta = (timestamp - lastTime) / 1000;
                lastTime = timestamp;

                offset += (isTop ? -1 : 1) * speed * delta;

                // Same conditions as before, in the track's own coordinates: the first slide has fully left the
                // track (top track: past the left edge; bottom track, flex-row-reverse: past the right edge).
                if (slideWidth) {
                    if (isTop && offset + slideWidth < 0) {
                        offset += slideWidth;
                        slider.appendChild(slider.children[0]);
                    }

                    if (!isTop && offset > slideWidth) {
                        offset -= slideWidth;
                        slider.appendChild(slider.children[0]);
                    }
                }

                slider.style.transform = `translateX(${offset}px)`;

                requestAnimationFrame(tick);
            }

            animations.push({
                start() {
                    if (running) return;
                    running = true;
                    lastTime = null;
                    requestAnimationFrame(tick);
                },
                stop() {
                    running = false;
                },
            });
        });

        new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                animations.forEach((animation) => (entry.isIntersecting ? animation.start() : animation.stop()));
            });
        }, { rootMargin: '200px 0px' }).observe(slidingSection);

        // === PARALLAX / STICKY ===
        const sectionAbove = slidingSection.previousElementSibling;
        if (!sectionAbove) return;

        // Sticky: sektionen ovanför
        sectionAbove.style.position = "sticky";
        sectionAbove.style.top = "104px";
        sectionAbove.style.zIndex = "0";
        sectionAbove.style.willChange = "transform";
        sectionAbove.style.paddingBottom = "400px";
        sectionAbove.style.transform = "translateZ(0)";
        sectionAbove.style.backfaceVisibility = "hidden";

        // Sliding-sektionen
        slidingSection.style.position = "relative";
        slidingSection.style.zIndex = "2";
        slidingSection.style.willChange = "transform";
        slidingSection.style.transform = "translateZ(0)";
        slidingSection.style.backfaceVisibility = "hidden";
        slidingSection.style.overflow = "visible";

        // Alla sektioner efter sliding-sektionen får samma GPU-lager och transform
        let nextSibling = slidingSection.nextElementSibling;
        while (nextSibling) {
            nextSibling.style.position = "relative";
            nextSibling.style.zIndex = "1";
            nextSibling.style.willChange = "transform";
            nextSibling.style.transform = "translateZ(0)";
            nextSibling.style.backfaceVisibility = "hidden";
            nextSibling.style.overflow = "visible";

            nextSibling = nextSibling.nextElementSibling;
        }

        // Parallax på sektionen ovanför
        window.addEventListener("scroll", () => {
            const rect = slidingSection.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            if (rect.top < windowHeight && rect.bottom > 0) {
                const progress = Math.min(Math.max((windowHeight - rect.top) / windowHeight, 0), 1);
                sectionAbove.style.transform = `translateY(${progress * -50}px) translateZ(0)`;
            } else {
                sectionAbove.style.transform = "translateY(0px) translateZ(0)";
            }
        }, { passive: true });

        // === GRADIENT ===
        const gradientDiv = slidingSection.querySelector(".sliding-images-gradient");
        if (gradientDiv) {
            const styleSliding = window.getComputedStyle(slidingSection);
            const slidingBg = styleSliding.backgroundColor || "rgb(255,255,255)";

            let match = slidingBg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/);
            let r = 255, g = 255, b = 255;
            if (match) {
                r = match[1];
                g = match[2];
                b = match[3];
            }

            gradientDiv.style.background = `linear-gradient(to bottom, rgba(${r},${g},${b},0) 0%, rgba(${r},${g},${b},1) 100%)`;
        }
    });
});

//# sourceMappingURL=sliding-images.js.map
